<script setup>

    // CheckoutPage
    // Allows the user to view and change the shipping information for the cart.

    // Components ----
    import CartBodyPanel from './components/CartBodyPanel';
    import ShipTo from './components/ShipTo';

    // Imports ----
    import { store } from '@/Store';
    import { ref } from 'vue';
    import { useRouter } from 'vue-router';

    const postalCodeValidationMessage = ref('');
    const router = useRouter();
    const isShippingAddressFormValid = ref(true);

    function checkContinueStatus(type) {
        postalCodeValidationMessage.value = '';
        if (!type.formIsValid) {
            isShippingAddressFormValid.value = false
            if (type.postalCodeValidationMessage)
                postalCodeValidationMessage.value = type.postalCodeValidationMessage
        }
        else {
            isShippingAddressFormValid.value = true
            postalCodeValidationMessage.value = ''
        }
    }

    function review() {
        router.push({ name: 'Review' });
    }

    async function handleBackToCartClick() {
        let response = await store.cart.setShipToModeToShipUser()

        if (response) {
            router.push('/cart')
        }
    }

</script>

<template>
    <PageTemplate>
        <div class="container root-page checkout-page">

            <div class="float-end">
                <PageButton class="me-2" :outline="true" @click="handleBackToCartClick">Back to Cart</PageButton>
                <button class="btn btn-color-1" v-if="!store.cart.isMultiShip()" @click="review"
                        :disabled="!isShippingAddressFormValid">
                    Continue
                </button>
            </div>

            <h1 class="cart-page-header mb-3">Checkout <span class="text-muted">/ Shipping</span></h1>

            <div v-if="!isShippingAddressFormValid && postalCodeValidationMessage" class="col-9 address-warning">
                <p>{{postalCodeValidationMessage}} . Please go to My Profile, Edit Shipping Address and correct the postal code. If you need assistance please send an email to <a href="mailto:sxmsupport@qualfon.com">sxmsupport@qualfon.com</a>.</p>
            </div>

            <div class="row">
                <div class="col-12 col-md-9">
                    <CartBodyPanel class="cart-body-panel">
                        <template #title>
                            <h2>Ship To</h2>
                        </template>

                        <ShipTo :editable="true" :editing="true" @addressType="checkContinueStatus" />

                    </CartBodyPanel>
                </div>

                <div class="col-12 col-md-3">
                    <CartBodyPanel class="cart-body-panel ship-method-panel">
                        <template #title>
                            <h2>Ship Method</h2>
                        </template>

                        <ShipMethodSelector v-model="store.cart.current.shipMethodCode" />
                    </CartBodyPanel>
                </div>
            </div>

        </div>
    </PageTemplate>
</template>

<style lang="scss">
    .root-page {
        min-height: 30rem;
    }

    .checkout-page {
        .n-body-panel {
            .body {
                padding: 0.75rem 0rem;
            }
        }

        .ship-method-panel {
            .body {
                padding-left: 1.5rem;
            }
        }
    }

    .address-warning {
        background-color: #fff;
        padding: 8px;
        margin: 0px;

        p {
            font-size: .85rem;
            margin: 0px;
            color: #ff0000
        }
    }
</style>